import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=71c97380&scoped=true&"
import script from "./tag.ts?vue&type=script&lang=ts&"
export * from "./tag.ts?vue&type=script&lang=ts&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=71c97380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c97380",
  null
  
)

export default component.exports